export default __webpack_public_path__ + "static/media/pouf4.776481b1.JPG";